import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    Link,
    CreateButton,
    FileInput,
    FileField,
    IconButtonWithTooltip,
    ButtonProps,
    useTranslate,
    useSimpleFormIteratorItem,
    ShowButton,
    useRefresh,
    ReferenceManyField,
    Pagination,
} from 'react-admin';
import { useController, useForm } from "react-hook-form";
import CloseIcon from '@mui/icons-material/RemoveCircleOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Grid from '@mui/material/Grid';
import Alert from "@mui/material/Alert";
// import { QuizzBuilder, Quiz } from "react-quizzes"
// import "react-quizzes/lib/assets/antd.css";
// import "./Forms.css";
// import "./FormEdit.scoped.css";
// import { sectionChoices } from "../helpers";
// import {ReactFormeoEditor, ReactFormeoRenderer} from "../Components/Formeo";
import { ConditionalScoringField, FormEntryCommunityField } from "./FormEntries";
import { formStatuses, getDesignations, getStatuses, sortBySequence, stateAbbrToName, toSelectChoices } from "../helpers/strings";
import { authenticatedApi } from "../dataProvider";
// import { FormeoEditor, FormeoRenderer } from 'formeo'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { AdditionalSchemaInput, additionalSchemaTypes } from "../Components/AdditionalSchema";
import { RichTextInput } from "ra-input-rich-text";
import { SimpleRichTextInputToolbar } from "../Components/SimpleRichTextInputToolbar";
import { ConfirmRemoveItemButton } from "../Components/ConfirmRemoveItemButton";
import { CreateInDialogButton, EditInDialogButton, ShowInDialogButton } from "@react-admin/ra-form-layout";
import { FormStandardEditForm, FormStandardShowLayout } from "./FormStandards";
import { FormKeyIndicatorEditForm } from "./FormKeyIndicators";
import { FormIndicatorEditForm } from "./FormIndicators";
import { FormBaselineRequirementEditForm } from "./FormBaselineRequirements";

/*
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
    useSortable,
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
*/

const scoringModeOptions = [
    { id: 'scored', name: 'Scored' },
    { id: 'scored_correctable', name: 'Scored with Ability to Correct & Resubmit' },
    { id: 'correctable', name: 'Correct Answers Before Submitting' },
];

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const FormList = props => (
    <List title={"All Forms"} filters={listFilters} {...props} hasCreate>
        <Datagrid rowClick="show">
            <TextField source="name" />
            <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} />
            {/* <SelectField source="section" choices={sectionChoices} /> */}
            {/* <TextField source="category" /> */}

            {/* type of form (form vs quiz) */}
        </Datagrid>
    </List>
);

export const FormField = (props) => {
    const record = useRecordContext(props);

    if(!record) {
        return null;
    }

    const formSchema = JSON.parse(record.schema);

    return null;

    // return <ReactFormeoRenderer formData={formSchema} values={[]} />
}

/*
const SortableTableRow = (props) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: props.id});

    const {id, ref, style: _style, ...restProps} = props;
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        ...(_style ? _style : {}),
    };

    return (
        <TableRow ref={setNodeRef} style={style} {...attributes} {...listeners} {...restProps}>
            {props.children}
        </TableRow>
    );
};
*/

const FormPreview = ({mode = 'show'}) => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();

    const [isReordering, setIsReordering] = React.useState(false);

    /*
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
          coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const [sortableStandardItems, setSortableStandardItems] = React.useState([]);
    React.useEffect(() => {
        // const items = useMemo(() => data?.map(({ id }) => id), [data]);
      setSortableStandardItems(record.standards.map(({id}) => id));
    }, [record]);
    */

    // the record can be empty while loading
    if (!record) return null;

    const ReorderButtons = ({resource, rows, item}) => {
        // const type = props.type;
        // const sequence = props.sequence;
        // const onChange = props.onChange;
        // const rows = props.rows;
        // const item = props.item;

        const isFirst = rows.indexOf(item) === 0;
        const isLast = rows.indexOf(item) === rows.length - 1;

        const performUpdate = (direction) => {
            setIsReordering(true);

            authenticatedApi.post(`/forms/reorder`, {
                resource,
                id: item.id,
                direction,
            }).then(response => {
                setIsReordering(false);
                refresh();
                notify('Order updated');
            });
        }


        //'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',

        return (<>
            {!isFirst && (
                <IconButtonWithTooltip
                    label="Move Up"
                    size="small"
                    onClick={() => {performUpdate('up')}}
                    color="warning"
                    disabled={isReordering}
                >
                    <ArrowUpwardIcon/>
                </IconButtonWithTooltip>
            )}
            {!isLast && (
                <IconButtonWithTooltip
                    label="Move Down"
                    size="small"
                    onClick={() => {performUpdate('down')}}
                    color="warning"
                    disabled={isReordering}
                >
                    <ArrowDownwardIcon/>
                </IconButtonWithTooltip>
            )}
        </>);
    };


    const urlSuffix = mode === 'show' ? '/show' : '';

    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                {/*
                <TableHead>
                <TableRow>
                    <TableCell>Title</TableCell>
                </TableRow>
                </TableHead>
                */}
                <TableBody>
                <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                >
                    <TableCell component="th" scope="row">
                        <Grid container spacing={2} justifyContent={'space-between'} alignItems={'center'} wrap="nowrap">
                            <Grid item>
                                Baseline Requirements
                            </Grid>
                            {/*
                            {mode === 'edit' && (
                                <Grid item>
                                    <CreateButton
                                        resource="form-baseline-requirements"
                                        label="Add Requirement"
                                        state={{record: {form_id: record.id}}}
                                    />
                                </Grid>
                            )}
                            */}
                        </Grid>
                    </TableCell>
                </TableRow>
                {record.baseline_requirements.sort(sortBySequence).map((requirement) => (<React.Fragment key={requirement.name}>
                    <TableRow
                    sx={{ '& > *': {fontStyle: 'italic'}, 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 }, '& p':{margin: 0} }}
                    >
                        <TableCell component="th" scope="row">
                            <Grid container spacing={2} justifyContent={'space-between'} alignItems={'center'} wrap="nowrap">
                                <Grid item>
                                    <div dangerouslySetInnerHTML={{__html: requirement.description}}></div>

                                    {Array.isArray(requirement.additional_schema) === true && requirement.additional_schema.length > 0 && (<>
                                        {requirement.additional_schema.map((additionalSchema, additionalSchemaIndex) => (
                                            <div key={additionalSchemaIndex} style={{display: 'flex', gap: '1rem'}}>
                                                <div dangerouslySetInnerHTML={{__html: additionalSchema.question}}></div>
                                                <em>{additionalSchemaTypes[additionalSchema.type]}</em>
                                            </div>
                                        ))}
                                    </>)}
                                </Grid>
                                <Grid item flexShrink={0}>
                                    {mode === 'show' && (<>
                                        <ShowButton resource="form-baseline-requirements" id={requirement.id}/>
                                    </>)}
                                    {mode === 'edit' && (<>
                                    <ReorderButtons resource="form-baseline-requirements" rows={record.baseline_requirements} item={requirement} />
                                    <EditInDialogButton resource="form-baseline-requirements" id={requirement.id} fullWidth maxWidth={false} mutationMode="pessimistic">
                                        <FormBaselineRequirementEditForm/>
                                    </EditInDialogButton>
                                    </>)}
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                </React.Fragment>))}
                {mode === 'edit' && (
                    <TableRow sx={{ 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row">
                            <CreateInDialogButton
                                resource="form-baseline-requirements"
                                label="Add Requirement"
                                record={{form_id: record.id}}
                                fullWidth maxWidth={false}
                            >
                                <FormBaselineRequirementEditForm/>
                            </CreateInDialogButton>
                            {/*
                            <CreateButton
                                resource="form-baseline-requirements"
                                label="Add Requirement"
                                state={{record: {form_id: record.id}}}
                            />
                            */}
                        </TableCell>
                    </TableRow>
                )}
                {record.standards.sort(sortBySequence).map((standard) => (<React.Fragment key={standard.name}>
                    <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Grid container spacing={2} justifyContent={'space-between'} alignItems={'center'} wrap="nowrap">
                                <Grid item>
                                    {standard.name}
                                </Grid>
                                <Grid item>
                                    {mode === 'show' && (<>
                                        {/*
                                        <ShowInDialogButton resource="form-standards" id={standard.id} fullWidth maxWidth={false}>
                                            <FormStandardShowLayout/>
                                        </ShowInDialogButton>
                                        */}
                                        <ShowButton resource="form-standards" id={standard.id}/>
                                    </>)}
                                    {mode === 'edit' && (<>
                                    <ReorderButtons resource="form-standards" rows={record.standards} item={standard} />
                                    <EditInDialogButton resource="form-standards" id={standard.id} fullWidth maxWidth={false} mutationMode="pessimistic">
                                        <FormStandardEditForm/>
                                    </EditInDialogButton>
                                    {/*
                                    <CreateButton
                                        resource="form-key-indicators"
                                        label="Add Key Indicator"
                                        state={{record: {form_standard_id: standard.id}}}
                                    />
                                    */}
                                    </>)}
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                    {standard.key_indicators.sort(sortBySequence).map((keyIndicator) => (<React.Fragment key={keyIndicator.name}>
                        <TableRow
                            sx={{ 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <Grid container spacing={2} justifyContent={'space-between'} alignItems={'center'} wrap="nowrap">
                                    <Grid item sx={{fontStyle: 'italic'}}>
                                        {keyIndicator.name}
                                    </Grid>
                                    <Grid item>
                                        {mode === 'show' && (<>
                                            <ShowButton resource="form-key-indicators" id={keyIndicator.id}/>
                                        </>)}
                                        {mode === 'edit' && (<>
                                        <ReorderButtons resource="form-key-indicators" rows={standard.key_indicators} item={keyIndicator} />
                                        <EditInDialogButton resource="form-key-indicators" id={keyIndicator.id} fullWidth maxWidth={false} mutationMode="pessimistic">
                                            <FormKeyIndicatorEditForm/>
                                        </EditInDialogButton>
                                        {/*
                                        <CreateButton
                                            resource="form-indicators"
                                            label="Add Indicator"
                                            state={{record: {form_key_indicator_id: keyIndicator.id}}}
                                        />
                                        */}
                                        </>)}
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                        {keyIndicator.indicators.sort(sortBySequence).map((indicator) => (<React.Fragment key={indicator.name}>
                            <TableRow
                                sx={{ 'th': {paddingLeft: 12}, '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Grid container spacing={2} justifyContent={'space-between'} alignItems={'center'} wrap="nowrap">
                                        <Grid item sx={{fontStyle: 'italic'}}>
                                            {indicator.name}
                                        </Grid>
                                        <Grid item>
                                            {mode === 'show' && (<>
                                                <ShowButton resource="form-indicators" id={indicator.id}/>
                                            </>)}
                                            {mode === 'edit' && (<>
                                            <ReorderButtons resource="form-indicators" rows={keyIndicator.indicators} item={indicator} />
                                            <EditInDialogButton resource="form-indicators" id={indicator.id} fullWidth maxWidth={false} mutationMode="pessimistic">
                                                <FormIndicatorEditForm/>
                                            </EditInDialogButton>
                                            </>)}
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell> */}
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell> */}
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell> */}
                            </TableRow>
                        </React.Fragment>))}
                        {mode === 'edit' && (
                        <TableRow sx={{ 'th': {paddingLeft: 12}, '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">
                                <CreateInDialogButton
                                    resource="form-indicators"
                                    label="Add Indicator"
                                    record={{form_key_indicator_id: keyIndicator.id}}
                                    fullWidth maxWidth={false}
                                >
                                    <FormIndicatorEditForm/>
                                </CreateInDialogButton>
                                {/*
                                <CreateButton
                                    resource="form-indicators"
                                    label="Add Indicator"
                                    state={{record: {form_key_indicator_id: keyIndicator.id}}}
                                />
                                */}
                            </TableCell>
                        </TableRow>
                        )}
                    </React.Fragment>))}
                    {mode === 'edit' && (
                    <TableRow sx={{ 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row">
                            <CreateInDialogButton
                                resource="form-key-indicators"
                                label="Add Key Indicator"
                                record={{form_standard_id: standard.id}}
                                fullWidth maxWidth={false}
                            >
                                <FormKeyIndicatorEditForm/>
                            </CreateInDialogButton>
                            {/*
                            <CreateButton
                                resource="form-key-indicators"
                                label="Add Key Indicator"
                                state={{record: {form_standard_id: standard.id}}}
                            />
                            */}
                        </TableCell>
                    </TableRow>
                    )}
                </React.Fragment>))}
                {mode === 'edit' && (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row">
                            <CreateInDialogButton
                                resource="form-standards"
                                label="Add Standard"
                                record={{form_id: record.id}}
                                fullWidth maxWidth={false}
                            >
                                <FormStandardEditForm/>
                            </CreateInDialogButton>
                            {/*
                            <CreateButton
                                resource="form-standards"
                                label="Add Standard"
                                state={{record: {form_id: record.id}}}
                            />
                            */}
                        </TableCell>
                    </TableRow>
                )}

                {mode === 'show' && Array.isArray(record.additional_schema) && record.additional_schema.length && (<>
                    <TableRow
                        sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">Additional Questions</TableCell>
                    </TableRow>
                    {record.additional_schema.map((additionalSchema, additionalSchemaIndex) => (
                        <TableRow
                            key={additionalSchemaIndex}
                            sx={{ '& > *': {fontStyle: 'italic'}, 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 }, '& p':{margin: 0} }}
                        >
                            <TableCell component="th" scope="row" style={{display: 'flex', gap: '1rem'}}>
                                <div dangerouslySetInnerHTML={{__html: additionalSchema.question}}></div>
                                <em>{additionalSchemaTypes[additionalSchema.type]}</em>
                            </TableCell>
                        </TableRow>
                    ))}
                </>)}
                </TableBody>
            </Table>
        </TableContainer>
    </>);
};

const FormEntriesField = () => {
    const record = useRecordContext();
    return (
        <ReferenceManyField
            reference="form-entries"
            target="form_id"
            label={false}
            perPage={25}
            pagination={<Pagination />}
        >
            <Datagrid rowClick={(id, resource, record) => '/form-entries/'+id+'/show'} bulkActionButtons={false}>
                <FunctionField label="Status" source="status" render={record => getStatuses(record.status)} />
                <FormEntryCommunityField label="Community" source="community" />
            </Datagrid>
        </ReferenceManyField>
    );
};

const FormScoringFields = () => {
    const record = useRecordContext();

    const displayScore = record && record.scoring_mode && record.scoring_mode !== null && record.scoring_mode.indexOf('scored') !== -1;

    if(!displayScore) {
        return null;
    }

    return (<>
        <SelectField source="scoring_mode" emptyValue={null} emptyText={'Not Scored'} choices={scoringModeOptions} />
        <NumberField source="minimum_score" />
    </>);

};

const FormShowActions = () => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [user, setUser] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();

    const [open, setOpen] = React.useState(false);

    /*
    const [remove, { isLoading }] = useDelete(
        'posts',
        { id: record && record.id }
    );
    */

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        setLoading(true);

        authenticatedApi.post(`/forms/${record.id}/duplicate`).then(response => {
            redirect('show', 'forms', response.data.id);
            setLoading(false);
            notify('Form duplicated', {type: 'success'});
        });

        // remove();
        setOpen(false);
    };

    return (
    <TopToolbar>
        <Button color="primary" onClick={handleClick}><>Duplicate</></Button>
        <Confirm
            isOpen={open}
            loading={loading}
            title={`Duplicate form?`}
            content="Are you sure you want to duplicate this form?"
            onConfirm={handleConfirm}
            onClose={handleDialogClose}
        />

        <EditButton />
    </TopToolbar>
    );
};

const FormShow = props => (
    <Show {...props} actions={<FormShowActions/>}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="summary">
                <TextField source="name" />

                <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} />

                <DateField label="Open On" source="start_at" />
                <DateField label="Close On" source="end_at" />
                <TextField label="Completion Redirect URL" source="completion_redirect_url" />
            </Tab>
            <Tab label="Table of Contents">
                {/*
                <em>Click on a title to navigate to that specific section.</em>
                <div>
                <CreateButton resource="form-baseline-requirements" label="Add Baseline Requirement" />
                <br/>
                <CreateButton resource="form-standards" label="Add Standard" />
                <br/>
                <CreateButton resource="form-key-indicators" label="Add Key Indicator" />
                <br/>
                <CreateButton resource="form-indicators" label="Add Indicator" />
                </div>
                */}
                <FormPreview/>
                {/* <FormPrint/> */}
            </Tab>
            <Tab label="Form Entries">
                <FormEntriesField/>
            </Tab>
            <Tab label="Communities">
                <ArrayField source="communities" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/communities/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField source="name" sortable={false} />
                        <TextField source="city" sortable={false} />
                        <FunctionField label="State" source="state" sortable={false} render={record => stateAbbrToName(record.state)} />
                        {/* <TextField source="zip" /> */}

                        <FunctionField label="Designation" source="designation" sortable={false} render={record => getDesignations(record.designation ?? null)} />
                    </Datagrid>
                </ArrayField>
            </Tab>
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
)

export const MyToolbar = () => (
  <Toolbar>
      <SaveButton label="Save" onClick={() => {
        const fields = document.querySelectorAll('.formeo-editor [required]');
          for(const field of fields) {
              field.removeAttribute('required');
          }
      }} />
  </Toolbar>
);

const FormStandardsEditor = () => {
    const record = useRecordContext();

    /*
    <ArrayInput source="items">
                <SimpleFormIterator inline>
                    <TextInput source="name" helperText={false} />
                    <NumberInput source="price" helperText={false} />
                    <NumberInput source="quantity" helperText={false} />
                </SimpleFormIterator>
            </ArrayInput>
    */

    return (<>
        <TabbedForm>
            <ArrayInput source="standards">
                <SimpleFormIterator>
                <TabbedForm.Tab label='name'>
                    <TextField source="name" />
                </TabbedForm.Tab>
                </SimpleFormIterator>
            </ArrayInput>
            {/*
            {record.standards.map((standard, sIndex) => {
                <TabbedForm.Tab label={standard.name}>
                    <TextField source={} />
                </TabbedForm.Tab>
            })}
            */}
        </TabbedForm>
    </>);
    //
};

const FormEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic" queryOptions={{meta: {edit: 1}}}>
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextInput source="name" isRequired fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        {/* TODO: Add note that setting to published will  */}
                        <SelectInput source="status" emptyText={'Choose...'} choices={toSelectChoices(formStatuses)} isRequired fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <DateInput label="Open On" source="start_at" isRequired fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <DateInput label="Close On" source="end_at" isRequired fullWidth />
                    </Grid>

                    <Grid item xs={12}>
                        <TextInput
                            source="completion_redirect_url"
                            label="Completion Redirect URL"
                            helperText="Optional. Users will be sent here after submitting their self-assessment."
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <RichTextInput source="description" label="Description / Introduction" isRequired fullWidth toolbar={<SimpleRichTextInputToolbar />} />

                        <RichTextInput source="how_grading_works" label="How Grading Works" isRequired fullWidth toolbar={<SimpleRichTextInputToolbar />} />

                        <ArrayInput source="grading_scale" label={"Grading Scale"}>
                            <SimpleFormIterator
                                fullWidth
                                inline
                                getItemLabel={index => <span style={{marginTop: '1rem'}}>#{index + 1}</span>}
                                disableClear
                                disableReordering
                                removeButton={<ConfirmRemoveItemButton/>}
                                // disableAdd={formData.additional_schema && formData.additional_schema.length > (maxQuestions - 1)}
                                // addButton={formData.additional_schema && formData.additional_schema.length === 0 ? <Button label="Add Question"><AddIcon size="small"/></Button> : <AddItemButton label="Add Question" />}
                            >
                                <NumberInput source="score" min={1} max={10} isRequired />
                                <TextInput source="name" isRequired />
                                <TextInput source="description" isRequired multiline fullWidth />

                            </SimpleFormIterator>
                        </ArrayInput>
                    </Grid>

                    <Grid item xs={6}>
                        <Stack>
                            <FileInput source="media" label="Sample Assessment" multiple>
                                <FileField source="original_url" title="file_name" />
                            </FileInput>
                        </Stack>
                    </Grid>
                </Grid>
            </TabbedForm.Tab>

            {/* Overview - Introduction, How Grading Works, Sample Assessment */}

            <TabbedForm.Tab label="Edit Assessment">
                <p style={{marginTop: 0, marginBottom: '2rem'}}>
                    <em>Use the arrows to reorder the form. Note that form order is saved as soon as you press the arrow.</em>
                </p>
                {/* <br/><br/> */}
                {/*
                <CreateButton resource="form-standards" label="Add Standard" />
                <CreateButton resource="form-key-indicators" label="Add Key Indicator" />
                <CreateButton resource="form-indicators" label="Add Indicator" />
                */}

                <FormPreview mode="edit"/>
                {/* <FormPrint/> */}
            </TabbedForm.Tab>
            {/*
            <TabbedForm.Tab label="Edit Form">
                <Alert severity="info">Please use the form's Table of Contents to make edits.</Alert>
            </TabbedForm.Tab>
             */}
             <TabbedForm.Tab label="Additional Questions">
                <AdditionalSchemaInput/>
            </TabbedForm.Tab>
        </TabbedForm>
    </Edit>
);

const FormCreate = props => {
  return (
    <Create {...props} redirect="show">
        <Alert severity="info">Note: It is recommended to duplicate a past form instead of starting from scratch.</Alert>
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Stack>
                            <TextInput source="name" isRequired />

                            {/* <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} /> */}
                            <SelectInput source="status" emptyText={'Choose...'} choices={toSelectChoices(formStatuses)} />
                            {/* TODO: Add note that setting to published will  */}

                            <DateInput label="Open On" source="start_at" isRequired />
                            <DateInput label="Close On" source="end_at" isRequired />
                            <TextInput
                                source="completion_redirect_url"
                                label="Completion Redirect URL"
                                helperText="Optional. Users will be sent here after submitting their self-assessment."
                                fullWidth
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Edit Form">

                {/* <EditableDa */}

                {/* <FormStandardsEditor/> */}

            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
)
};

export {FormList, FormShow, FormEdit, FormCreate};
